export default "__VITE_ASSET__DNg55ol___"